"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var div = document.createElement("div");
    div.innerHTML = '\n    <h2 class="title">'.concat(title, "</h2>\n    <p>").concat(description, "</p>\n  ");
    div.classList.add("notification", type);
    div.style.top = posTop + "px";
    div.style.right = posRight + "px";
    document.body.append(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.3aff17a5.js.map
